import { render, staticRenderFns } from "./FooterDynamic.vue?vue&type=template&id=29f8f7f6&scoped=true&"
import script from "./FooterDynamic.vue?vue&type=script&lang=js&"
export * from "./FooterDynamic.vue?vue&type=script&lang=js&"
import style0 from "./FooterDynamic.vue?vue&type=style&index=0&id=29f8f7f6&lang=scss&scoped=true&"
import style1 from "./FooterDynamic.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29f8f7f6",
  null
  
)

export default component.exports